import React, { useState } from "react";
import PropTypes from "prop-types";
import Logo from "../Image/Logo";
import { Link } from "gatsby";
import Hamburger from "../Image/Hamburger";
import "./Header.scss";

const Header = ({ siteTitle }) => {
  const [buggerOpen, setBuggerOpen] = useState(false);
  const [dropdownStates, setDropdownStates] = useState({}); // Track dropdown states for each index

  const menuItems = [
    { name: "Services", path: "/services" },
    { name: "PIM", path: "/pim" },
    { name: "Search", path: "/search" },
    { name: "Work", path: "/work" },
    { name: "About", path: "/about" },
    { name: "Blog", path: "/blog" },
    { name: "Contact Us", path: "/contact" },
  ];

  const toggleMenu = () => {
    setBuggerOpen((prev) => !prev);
  };

  const toggleDropdown = (index) => {
    setDropdownStates((prev) => ({
      ...prev,
      [index]: !prev[index], // Toggle the specific dropdown state
    }));
  };

  return (
    <header className="fixed top-0 z-[1030] w-full bg-hamariBlue">
      <span className="hidden">{siteTitle}</span>
      <div className="container max-w-[125rem] px-0 lg:!px-4 mx-auto">
        <div className="lg:flex lg:!py-[0.7rem]">
          <div className="flex px-4">
            <Link to={"/"} className="lg:p-0 lg:pl-8 flex items-center">
              <div className="logo pr-2">
                <Logo />
              </div>
              <span className="text-white hover:!text-neutral-500 font-normal text-2xl font-coreCircus">
                {siteTitle}
              </span>
            </Link>
            <Hamburger onClick={toggleMenu} />
          </div>
          <div
            className={`lg:ml-auto ${buggerOpen
              ? "transition-opacity duration-500 ease-in-out opacity-100 visible bg-hamariDark lg:bg-[inherit] h-screen overflow-y-auto"
              : "transition-opacity duration-500 ease-in-out opacity-0 invisible !h-0 lg:!h-auto"
              } lg:!visible lg:opacity-100 w-full lg:w-auto lg:flex items-center`}
          >
            <div className="flex flex-col lg:flex-row relative gap-1 py-4 mm-nav">
              {menuItems.map((menu, index) => (
                <div
                  key={index}
                  onClick={
                    [0, 1, 2].includes(index) ? () => toggleDropdown(index) : undefined
                  }
                  className={`${index === 0 ? "border-0" : "border-t"
                    } ${[0, 1, 2].includes(index)
                      ? `caretDesktop mm-main-btn ${dropdownStates[index] ? "caretUp" : "caretDown"
                      }`
                      : ""
                    } group lg:border-t-0 border-neutral-500`}
                >
                  <a
                    href={`${menu.path}/`}
                    className={`text-white tracking-[1px] ${index === 6 ? "mm-contact" : ""
                      } lg:border-t-0 border-neutral-500 text-[14px] font-bold font-montserrat mm-btns`}
                  >
                    {menu.name}
                  </a>
                  {[0, 1, 2].includes(index) && (
                    <div
                      className={`${dropdownStates[index] ? "block" : "hidden"
                        } mm-menu text-[14px] font-montserrat p-4 lg:!p-0 drop-down lg:absolute md:group-hover:block bg-hamariDark text-hamariWhite`}
                    >
                      <div className="flex flex-col">
                        {index === 0 && (
                          <>
                            <div className="flex flex-col lg:flex-row lg:gap-12">
                              <div>
                                <p className="font-bold pt-3 pb-1">
                                  PIM Product Data & Content
                                </p>
                                <a href="/services/pim-taxonomy-data-modeling/">
                                  PIM Taxonomy & Data Modeling
                                </a>
                                <a href="/services/pim-content-creation-and-enrichment/">
                                  Product Content creation and enrichment
                                </a>
                                <a href="/services/product-content-normalization-data-cleansing/">
                                  Product content normalization & data cleansing
                                </a>
                                <a href="/services/pim-ecommerce-data-migration/">
                                  PIM & E-commerce data migration
                                </a>
                                <p className="font-bold pt-3 pb-1">
                                  PIM Implementation & Integration
                                </p>
                                <a href="/services/pim-audit/">PIM Audit</a>
                                <a href="/services/pim-integration/">
                                  PIM Integration
                                </a>
                                <a href="/services/pim-selection/">PIM Selection</a>
                                <a href="/services/pim-support/">PIM Support</a>
                                <p className="font-bold pt-3 pb-1">
                                  DAM Implementation & Consulting
                                </p>
                                <a href="/services/dam-implementation/">DAM Implementation</a>
                                <a href="/services/dam-consulting/">DAM Consulting</a>
                              </div>
                              <div>
                                <p className="font-bold pt-3 pb-1">
                                  Pimcore
                                </p>
                                <a
                                  href="/services/pimcore-implementation-partner/"
                                  aria-label="Pimcore Implementation Partner services by Hamari"
                                  title="Pimcore Implementation Partner services"
                                >
                                  Pimcore Implementation Partner
                                </a>
                                <a
                                  href="/services/pimcore-upgrade/"
                                >
                                  Pimcore Upgrade Services
                                </a>
                                <a
                                  href="/services/pimcore-connector/"
                                >
                                  Pimcore eCommerce Connectors
                                </a>
                                <a
                                  href="/service/web2print/"
                                >
                                  Pimcore Web2Print
                                </a>
                                <a
                                  href="/services/pimcore-development-agency/"
                                  aria-label="Pimcore Development Agency services by Hamari"
                                  title="Pimcore Development Agency services"
                                >
                                  Pimcore Development
                                </a>
                                <a
                                  href="/services/pimcore-product-information-management/"
                                  aria-label="Pimcore Product Information Management (PIM) by Hamari"
                                  title="Pimcore Product Information Management (PIM)"
                                >
                                  Pimcore Product Information Management (PIM)
                                </a>
                                <a
                                  href="/services/pimcore-master-data-management/"
                                  aria-label="Pimcore Master Data Management (MDM) by Hamari"
                                  title="Pimcore Master Data Management (MDM)"
                                >
                                  Pimcore Master Data Management (MDM)
                                </a>
                                <a
                                  href="/services/pimcore-digital-experience-platform/"
                                  aria-label="Pimcore Digital Experience Platform (DXP) by Hamari"
                                  title="Pimcore Digital Experience Platform (DXP)"
                                >
                                  Pimcore Digital Experience Platform (DXP)
                                </a>
                                <a
                                  href="/services/pimcore-digital-asset-management/"
                                  aria-label="Pimcore Digital Asset Management (DAM) by Hamari"
                                  title="Pimcore Digital Asset Management (DAM)"
                                >
                                  Pimcore Digital Asset Management (DAM)
                                </a>
                                <a
                                  href="/services/pimcore-azure-deployment/"
                                  aria-label="Deploy Pimcore on Azure with Hamari"
                                  title="Deploy Pimcore on Azure"
                                >
                                  Pimcore on Azure
                                </a>
                              </div>
                            </div>
                          </>
                        )}
                        {index === 1 && (
                          <>
                            <div className="flex flex-col lg:flex-row lg:gap-12">
                              <div>
                                <p className="font-bold pt-3 pb-1">
                                  <a href="/pim/pim-for-various-industries/">
                                    PIM for Various Industries
                                  </a>
                                </p>
                                <a href="/pim/pim-for-b2b/">
                                  PIM for B2B
                                </a>
                                <a href="/pim/pim-for-b2c/">
                                  PIM for B2C
                                </a>
                                <a href="/pim/pim-for-distributors/">
                                  PIM for Distributors
                                </a>
                                <a href="/pim/pim-for-manufacturers/">
                                  PIM for Manufacturers
                                </a>
                                <a href="/pim/pim-for-retailers/">
                                  PIM for Retailers
                                </a>
                                <a href="/pim/pim-for-erp/">
                                  PIM for ERP
                                </a>
                                <a href="/pim/pim-for-e-commerce/">
                                  PIM for E-commerce
                                </a>
                                <a href="/pim/pim-for-marketplaces/">
                                  PIM for Marketplaces
                                </a>
                              </div>
                              <div>
                                <p className="font-bold pt-4 pb-1">
                                  Compare PIM Vendors
                                </p>
                                <a href="/pim/akeneo/">
                                  Akeneo
                                </a>
                                <a href="/pim/bluestone-pim/">
                                  Bluestone PIM
                                </a>
                                <a href="/pim/contentserv/">
                                  Contentserv
                                </a>
                                <a href="/pim/ergonode/">
                                  Ergonode
                                </a>
                                <a href="/pim/inriver/">
                                  Inriver
                                </a>
                                <a href="/pim/perfion/">
                                  Perfion
                                </a>
                                <a href="/pim/pimberly/">
                                  Pimberly
                                </a>
                                <a href="/pim/pimcore/">
                                  Pimcore
                                </a>
                                <a href="/pim/plytix/">
                                  Plytix
                                </a>
                                <a href="/pim/saleslayer/">
                                  Saleslayer
                                </a>
                                <a href="/pim/salsify/">
                                  Salsify
                                </a>
                                <a href="/pim/stibo-systems/">
                                  Stibo Systems
                                </a>
                              </div>
                            </div>
                          </>
                        )}
                        {index === 2 && (
                          <>
                            <p className="font-bold pt-4 pb-1">
                              Compare Search
                            </p>
                            <a href="/search/advanced-commerce/">
                              Advanced Commerce
                            </a>
                            <a href="/search/algolia/">
                              Algolia
                            </a>
                            <a href="/search/crownpeak-attraqt-fredhopper-and-xo/">
                              Attraqt XO & Fredhopper
                            </a>
                            <a href="/search/bloomreach-discovery/">
                              Bloomreach Discovery
                            </a>
                            <a href="/search/constructor/">
                              Constructor
                            </a>
                            <a href="/search/klevu/">
                              Klevu
                            </a>
                            <a href="/search/searchspring/">
                              Searchspring
                            </a>
                          </>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

Header.propTypes = {
  siteTitle: PropTypes.string,
};

Header.defaultProps = {
  siteTitle: ``,
};

export default Header;